import loadable from '@loadable/component'

export default {
    '/butRefund': loadable(() => import('./butRefund')),
    // '/caption/delivery-notice': loadable(() => import('./deliveryNotice')),
    // '/caption/delivery-notice2': loadable(() => import('./deliveryNotice2')),
    '/caption/delivery-notice4': loadable(() => import('./deliveryNotice4')),
    '/caption/new-shop-update': loadable(() => import('./NewShopUpdate')),
    '/caption/new-shop-tripe': loadable(() => import('./NewShopTripe')),
    '/:type/caption/eul/:id': loadable(() => import('./Eul')),
    '/:type/caption/mxDataReport': loadable(() => import('./mxDataReport')), // 四月民刑摸底模考数据报告
}
